// extracted by mini-css-extract-plugin
export default {"view":"value-field_view__77t6u","small":"value-field_small__VKRtE","large":"value-field_large__eFKpZ","label":"value-field_label__hr0Am","value":"value-field_value__mZfsT"};